import React, { useState, forwardRef, useImperativeHandle } from "react";

import "./styles.css";
import { ModalComponent } from "../modal/Modal";

export const Screenshot = forwardRef(({ viewer, folderPath }, ref) => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [image, setImage] = useState({ img: null, base64: "" });
  const [position, setPosition] = useState({ yaw: 0, pitch: 0 });

  const handleOpen = () => setIsOpenModal(true);
  const handleClose = () => setIsOpenModal(false);

  const captureScreenshot = async () => {
    return new Promise(resolve => {
      viewer.addEventListener(
        "render",
        () => {
          const dataUrl = viewer.renderer.renderer.domElement.toDataURL(
            "image/jpeg",
            1
          );
          resolve(dataUrl);
        },
        { once: true }
      );
      viewer.needsUpdate();
    });
  };

  const openModal = async () => {
    try {
      if (viewer) {
        const currentPosition = viewer.getPosition();
        setPosition(currentPosition);

        const image64 = await captureScreenshot();
        const blob = await fetch(image64).then(res => res.blob());
        const imageJpg = new File([blob], "screenshot.jpg", {
          type: "image/jpeg"
        });
        setImage({ img: imageJpg, base64: image64 });
        handleOpen();
      }
    } catch (err) {
      console.error("Error capturing screenshot:", err);
    } finally {
    }
  };

  useImperativeHandle(ref, () => ({
    openScreenshotModal: openModal
  }));

  return (
    <>
      <ModalComponent
        show={isOpenModal}
        closeModal={handleClose}
        image={image}
        position={position}
      />
    </>
  );
});
